import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorPendingBankingAccount = (
  internalAccount: InternalAccount
): boolean =>
  internalAccount.type === "Banking" && internalAccount.status === "Pending";
